import React, {useState} from 'react'
import EditIcon from '../../media/felsv/down-arrow-svgrepo-com.svg'
import SearchSelect from '../Inputs/SearchSelect'
import { useDispatch, useSelector } from 'react-redux'
import { State } from '../../reducers'
import { bindActionCreators } from 'redux'
import { actionsDocumentos } from '../../actions/action-creators'

const DocumentosReceptor = () => {
  const [showContent, setShowContent] = useState(false)
  const {tipoDocumento} = useSelector((state: State) => state.catalogos)
  const {form, errors} = useSelector((state: State) => state.documentos.datosReceptor)
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionsDocumentos, dispatch)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    acciones.docsDatosReceptorHandleChangeInput(e)
    acciones.docsDatosReceptorOnBlurInput(e)
  }
  const handleChangeCheck = (flag: boolean) => {
    if(!flag) acciones.docsDatosReceptorReset()
    acciones.docsDatosReceptorHandleChange({esReceptorManual: flag})
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card' style={{boxShadow: "none", width: '100%'}}>
        <div className='w-layout-vflex card-content'>
          <h3 className='card-title l' onClick={() => setShowContent(!showContent)} style={{cursor: 'pointer'}}>
            Responsable Receptor<img src={EditIcon} alt='open' style={{marginLeft: '16px', width: '15px'}} />
          </h3>
        </div>
        {showContent && <>
            <div className='w-layout-hflex h-inputs' style={{marginTop:"2%"}}>
              <label className='container-checkbox m'>Agregar receptor<input autoFocus type='checkbox' name='check-receptor' checked={form.esReceptorManual} onChange={() => handleChangeCheck(!form.esReceptorManual)} /><span className='checkmark-checkbox'></span></label>
            </div>        
            <div className='w-layout-hflex h-inputs' style={{marginTop:"1%"}}>
                <div className='label-input'>
                <label htmlFor='tipoDocumento' className='field-label m'>
                    Tipo de documento de identificación{ form.esReceptorManual && <span style={{color: 'red'}}>*</span>}
                </label>
                <SearchSelect
                    defaultValue={null}
                    disabled={!form.esReceptorManual}
                    placeholder='Tipo de Identificación'
                    value={form.tipoDocumento}
                    name='tipoDocumento'
                    data={tipoDocumento}
                    keyNameText='valor'
                    keyNameValue='codigo'
                    onChange={(value: any) => handleChange({target: {value: value?.value, name: 'tipoDocumento'},})}
                />
                {errors.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
                </div>
                <div className='label-input'>
                <label htmlFor='numId' className='field-label m'>
                    {form.nombreTipoDocumento ||  'Número de identificación'}{form.esReceptorManual && <span style={{color: 'red'}}>*</span>}
                </label>
                <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='numId'
                    data-name='numId'
                    placeholder={`Número de ${ form.nombreTipoDocumento || 'Identificación'}`}
                    id='numId'
                    disabled={!form.esReceptorManual}
                    maxLength={20}
                    value={form.numId}
                    onChange={handleChange}
                    onBlur={acciones.docsDatosReceptorOnBlurInput}
                />
                {errors.numId && <p className='alert s'>{errors.numId}</p>}
                </div>
                <div className='label-input'>
                <label htmlFor='nombre' className='field-label m'>
                    Nombre{form.esReceptorManual && <span style={{color: 'red'}}>*</span>}
                </label>
                <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='nombre'
                    data-name=''
                    placeholder='Nombre'
                    id='nombre'
                    disabled={!form.esReceptorManual}
                    maxLength={250}
                    value={form.nombre}
                    onChange={handleChange}
                    onBlur={acciones.docsDatosReceptorOnBlurInput}
                />
                {errors.nombre && <p className='alert s'>{errors.nombre}</p>}
                </div>
            </div>
        </>}
      </div>
    </div>
  )
}

export default DocumentosReceptor
